import React, { Component } from "react";
import Iframe from "@nicholasadamou/react-iframe";
import classNames from "classnames";
import { routerActions } from "react-router-redux";
import { connect } from "react-redux";
import { Box } from "@ui-kit/components/index.es";
import { actions as ecomexIframeActions, selectors } from "reducers/ecomexIframe";
import Notification from "pages/_components/Notification";
import { func, shape, string, bool } from "prop-types";
import PageLoading from "pages/_components/PageLoading";
import * as config from "util/config";
import { resizableRoute } from "pages/_components/Resizable";
import { applyEmbeddedV3ShellLayoutState, clearEmbeddedV3ShellLayoutState } from "util/v3ShellLayoutSync";

class EcomexRequestHistory extends Component {
    static propTypes = {
        dispatch: func.isRequired,
        error: shape({}),
        idTransaction: string,
        token: string,
        fetching: bool.isRequired,
        title: string,
        width: string,
        height: string,
        isDesktop: bool.isRequired,
        embeddedInV3Shell: bool,
    };

    static defaultProps = {
        error: null,
        token: null,
        idTransaction: null,
        width: "100%",
        height: "100%",
        embeddedInV3Shell: false,
        title: "Ecomex",
    };

    componentDidMount = () => {
        const { dispatch } = this.props;
        dispatch(ecomexIframeActions.loadRequestHistory());
        this.startFetching();
        this.syncEmbeddedV3ShellLayout();
    };

    componentDidUpdate = (prevProps) => {
        const { dispatch, idTransaction, error, embeddedInV3Shell, isDesktop } = this.props;
        if (error) {
            dispatch(routerActions.push(embeddedInV3Shell ? "/v3/dashboard" : "/desktop"));
        }
        if (idTransaction) {
            this.stopFetching();
            dispatch(routerActions.push(`/transaction/${idTransaction}`));
        }
        if (
            embeddedInV3Shell &&
            (prevProps.embeddedInV3Shell !== embeddedInV3Shell || prevProps.isDesktop !== isDesktop)
        ) {
            this.syncEmbeddedV3ShellLayout();
        }
    };

    componentWillUnmount = () => {
        const { dispatch, embeddedInV3Shell } = this.props;
        this.stopFetching();
        dispatch(ecomexIframeActions.cleanUp());
        if (embeddedInV3Shell) {
            clearEmbeddedV3ShellLayoutState(dispatch);
        }
    };

    syncEmbeddedV3ShellLayout = () => {
        const { dispatch, embeddedInV3Shell, isDesktop } = this.props;
        applyEmbeddedV3ShellLayoutState(dispatch, {
            embeddedInV3Shell,
            isDesktop,
            scopes: ["pages.ecomexIframe"],
            titleKey: "menu.ecomex.requestsHistory",
            goBackPath: "/v3/dashboard",
        });
    };

    fetchTransactionId = () => {
        const { dispatch, token } = this.props;
        if (token !== null) {
            dispatch(ecomexIframeActions.fetchTransaction(token));
        }
    };

    startFetching = () => {
        if (!this.interval) {
            this.interval = setInterval(this.fetchTransactionId, 3000);
        }
    };

    stopFetching = () => {
        if (this.interval) {
            clearInterval(this.interval);
            this.interval = null;
        }
    };

    render() {
        const { fetching, title, width = "100%", height = "100%", token, embeddedInV3Shell } = this.props;
        const url = config.get("ecomex.service.url.requestHistory");
        const encodedToken = encodeURIComponent(token);
        const urlWithHash = `${url}?hashid=${encodedToken}`;

        return (
            <PageLoading loading={fetching}>
                {!embeddedInV3Shell && (
                    <Notification scopeToShow="pages.ecomexIframe" notificationClassname="navbar-fixed-top" />
                )}
                {token && (
                    <Box
                        w="100%"
                        px={0}
                        className={classNames(
                            "ecomex-iframe__container",
                            embeddedInV3Shell
                                ? "ecomex-iframe__container--v3-shell"
                                : "ecomex-iframe__container--legacy",
                        )}>
                        <Iframe
                            src={urlWithHash}
                            headers={{
                                Authorization: token,
                                "Access-Control-Allow-Origin": "*",
                            }}
                            frameBorder="0"
                            title={title}
                            width={width}
                            height={height}
                            className="ecomex-iframe__frame"
                        />
                    </Box>
                )}
            </PageLoading>
        );
    }
}

const mapStateToProps = (state) => ({
    token: selectors.getToken(state),
    error: selectors.getError(state),
    fetching: selectors.getFetching(state),
    idTransaction: selectors.getIdTransaction(state),
});
export default connect(mapStateToProps)(resizableRoute(EcomexRequestHistory));
